import React, { useEffect, useState } from 'react'
import Module from '../../../../layout/Module'
import { Routes, Route } from 'react-router-dom'
import TabsLink from '../../../../tabs/TabsLink'
import Period from './Period/Period'
import General from './General/General'
import SpecialCircumstances from './SpecialCircumstances/SpecialCircumstances'
import Types from './Types/Types'
import AssessmentAreas from './AssessmentAreas/AssessmentAreas'
import { getCurriculum } from '../../../../../services/curriculum/curriculum.service'
import { handlerErrorV2 } from '../../../../../utils/errors'
import Rating from './Ratings/Ratings'
import EffortAndConduct from './EffortAndConduct/EffortAndConduct'

const PeriodicalReportSetting = () => {
  const [data, setData] = useState(null)
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true)
      try {
        const response = await getCurriculum(true)
        if (!response?.data && response?.error) {
          console.error(response.error.message || 'An error ocurred')
        } else {
          setData(response?.data || null)
        }
      } catch (error) {
        const message = handlerErrorV2(error)
        console.error(message)
      } finally {
        setIsLoading(false)
      }
    }
    fetchData()
  }, [])

  return (
    <>
      <Module.BodyHeader>
        <div className='relative overflow-hidden w-full h-full flex items-end'>
          <TabsLink
            id='school'
            items={[
              {
                id: 'general',
                name: 'General',
                path: '/dashboard/periodical-report/setting',
                permission: true,
                end: true
              },
              {
                id: 'period',
                name: 'Periods',
                path: '/dashboard/periodical-report/setting/period',
                permission: true,
                end: true
              },
              {
                id: 'type',
                name: 'Types',
                path: '/dashboard/periodical-report/setting/type',
                permission: true,
                end: true
              },
              {
                id: 'special-circumstances',
                name: 'Special circumstances',
                path: '/dashboard/periodical-report/setting/special-circumstances',
                permission: true,
                end: true
              },
              {
                id: 'assessment-area',
                name: 'Assessment areas',
                path: '/dashboard/periodical-report/setting/assessment-area',
                permission: true,
                end: true
              },
              {
                id: 'rating',
                name: 'Ratings',
                path: '/dashboard/periodical-report/setting/rating',
                permission: true,
                end: true
              },
              {
                id: 'effort-and-conduct',
                name: 'Effort and conduct',
                path: '/dashboard/periodical-report/setting/effort-and-conduct',
                permission: true,
                end: true
              }
            ]}
          />
        </div>
      </Module.BodyHeader>
      <Module.BodyContainer classNameWrapper='overflow-auto'>
        <Routes>
          <Route index element={<General />} />
          <Route path='period' element={<Period curriculum={data || []} isLoadingCurriculum={isLoading} />} />
          <Route path='type' element={<Types curriculum={data || []} isLoadingCurriculum={isLoading} />} />
          <Route
            path='special-circumstances'
            element={<SpecialCircumstances curriculum={data || []} isLoadingCurriculum={isLoading} />}
          />
          <Route
            path='assessment-area'
            element={<AssessmentAreas curriculum={data || []} isLoadingCurriculum={isLoading} />}
          />
          <Route path='rating' element={<Rating />} />
          <Route path='effort-and-conduct' element={<EffortAndConduct />} />
        </Routes>
      </Module.BodyContainer>
    </>
  )
}

export default PeriodicalReportSetting
